import { getAliossSetting } from "@/api/public";
import { TResponse } from "@/module/common";
import { TCollectDataType } from "@/module/collect";
import { TDownType } from "@/module/public";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import router from "@/router";

const extArr = ['doc', 'docx', 'ppt', 'pptx', 'xlsx', 'xls', 'pdf', 'cda', 'wav', 'mp3', 'aif', 'aiff', 'mid', 'wma', 'ra', 'vqf', 'ape', 'avi', 'wmv', 'mpeg', 'mp4', 'm4v', 'mov', 'asf', 'flv', 'f4v', 'rmvb', 'rm', '3gp', 'vob', 'jpg', 'jpeg', 'bmp', 'gif', 'png', 'tiff', 'svg', 'txt']
function fileHandle() {

    const previewPic = ref()

    const onPreview = (row: TCollectDataType, index: number) => {
        if (row.ObjType===3){
            if (row.Type === 4) {
                return
            }
            let html = ''
            if (row.Size / 1024.0 > 5 && row.Type === 2) {
                html = `<div style="
                            text-align: center;
                            position: absolute;
                            top: 45%;
                            color: white;
                            left: 45%;
                            font-size: 18px;
                        ">文件大于5M,无法预览${row.DownState ? '请下载查看' : ''}</div>`
            } else {
                if (row.Type === 1) {
                    html = `<iframe src="${row.Url}" frameborder="0" style="" width='100%' height='100%'></iframe>`
                }
                if (row.Type === 3) {
                    html = `<iframe srcdoc="<div align='center'><audio src='${row.Url}' controls='controls' /></div>"  frameborder="0" style="" width='100%' height='100%'></iframe>`
                }
                if (row.Type === 2) {
                    const typeArr = ['doc', 'docx', 'ppt', 'pptx', 'xlsx', 'xls']
                    const exts = ['pdf']
                    var ext = row.Url.split('.')[row.Url.split('.').length - 1]
                    if (exts.indexOf(ext) !== -1) {
                        html = `<iframe src="${row.Url}" frameborder="0" style="" width='100%' height='100%'></iframe>`
                    } else if (typeArr.indexOf(ext) !== -1) {
                        // 使⽤微软的office online
                        // row.Url = 'https://view.officeapps.live.com/op/view.aspx?src=' + row.Url

                        row.Url = 'https://view.officeapps.live.com/op/embed.aspx?src=' + row.Url
                        
                        if (row.Url.indexOf("192.168") !== -1 || row.Url.indexOf("localhost") !== -1) {
                            html = `<iframe srcdoc="<div align='center' style='color:#ffffff'>局域网文件无法预览、请使用外网可访问文件</div>" frameborder="0" style="" width='100%' height='100%'></iframe>`
                        } else {
                            html = `<iframe src="${row.Url}" frameborder="0" style="" width='100%' height='100%'>无法预览时请下载</iframe>`
                            if(ext==='doc' || ext==='docx')
                            {
                                html +=`<div style="
                                width: 50%;
                                position: relative;
                                top: -22px;
                                left: 50%;
                                height: 22px;
                                background-color: #ffffff;
                                border-top: 1px solid #e1e1e1;"></div>`
                            }else if(ext==='ppt' || ext==='pptx'){
                                html +=`<div style="
                                width: 50%;
                                position: relative;
                                top: -22px;
                                left: 50%;
                                height: 22px;
                                background-color: #444444;
                                border-top: 1px solid #555555;"></div>`
                            }
                        }

                    } else {
                        ElMessage.error("暂未实现预览该文件")
                        return false
                    }
                }
            }
            if (row.DownState) {
                ElMessageBox.alert(html, {
                    dangerouslyUseHTMLString: true,
                    showConfirmButton: true,
                    center: true,
                    title: "预览",
                    distinguishCancelAndClose: false,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false,
                    cancelButtonText: '',
                    confirmButtonText: '关闭',
                    customClass: 'sn-message-box',
                    beforeClose: function (action, instance, done) {
                        done()
                    },
                }).then(() => {
                    // 下载
                    // downLoad(row)
                })
            } else {
                ElMessageBox.alert(html, {
                    dangerouslyUseHTMLString: true,
                    showConfirmButton: true,
                    center: true,
                    title: "预览",
                    distinguishCancelAndClose: true,
                    showCancelButton: true,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: true,
                    confirmButtonText: '关闭',
                    customClass: 'sn-message-box',
                    // cancelButtonText: '关闭',
                    beforeClose: function (action, instance, done) {
                        done()
                    },
                })
            }
        } else if (row.ObjType === 1){
            router.push({ name: 'recordDetails', query: { NodeId: row.NodeId, Id: row.Id,IsCollect:1 } })
        }
    }

    const downLoad = async (item: TCollectDataType) => {
        let client = null
        let res: TResponse<TDownType> = await getAliossSetting()
        let { Code, Data } = res
        if (Code === 200) {
            const OSS = require('ali-oss');
            client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                region: Data.RegionId,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId: Data.AccessKeyID,
                accessKeySecret: Data.AccessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                // stsToken: 'yoursecurityToken',
                // 填写Bucket名称。
                bucket: Data.Bucket,
            });
        }
        // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
        var ext = item.Url.split('.')[item.Url.split('.').length - 1]
        const filename = item.Name + '.' + ext
        const response = {
            'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
        }
        // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
        const URL = client.signatureUrl(item.OldUrl, { response });
        window.location.href = URL
    }
    const addExtension = (row: TCollectDataType) => {
        if (row.ObjType===3){
            let ext = row.Name.split('.')[row.Name.split('.').length - 1]
            if (extArr.indexOf(ext) !== -1) {
                return row.Name
            }
            if (row.Extension.startsWith('.')) {
                return row.Name + row.Extension
            } else {
                return `${row.Name}.${row.Extension}`
            }
        } if (row.ObjType === 1) {
            return row.Name
        }
    }
    return {
        onPreview,
        addExtension,
        downLoad,
        previewPic

    }
}

export {
    fileHandle
}



